<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">
  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />

  <!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>
      

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        
        <div class="visitor-card shadow border-primary">
           
          
          <div class="card-body">
          <div class="d-flex justify-content-between align-items-center sticky-top">
                <button
              class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#dashboardSidebarOffcanvas"
              aria-controls="dashboardSidebarOffcanvas"
              aria-label="Open workspace menu"
            >
              <i class="bx bx-menu-alt-left fs-5"></i>
            </button>
              <div class="ms-auto">
                        <GetCommunityAssets ref="communityAssets" />
                    </div>
            </div>
          

            <!-- Main component -->
            <!-- ASSETS TABLE -->
            <div class="row g-2 mb-3">
              <div
                v-for="card in asset_dashboard_cards"
                :key="card.label"
                class="col-6 col-md-4 col-xl"
              >
                <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                  <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                    <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                      <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                      <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                    </div>
                    <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                      <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
             <div v-show="is_loading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Asset List...</p>
            </div>
            <div v-show="!is_loading">
            <div v-if="community_assets && community_assets.length">
                <div class="table-responsive">
                   
                    <table class="table align-middle table-striped table-borderless mb-0 data-table">
                        <thead class="btn-primary text-white sticky-top">
                            <tr>
                                <th class="text-xxs fw-light">No.</th>
                                <th class="text-xxs fw-light text-start">Asset</th>
                                <th class="text-xxs fw-light text-start">Category</th>
                                <th class="text-xxs fw-light text-start">Location</th>
                                <th class="text-xxs fw-light text-start">Owner</th>
                                <th class="text-xxs fw-light text-start">Status</th>
                                <th class="text-xxs fw-light text-start">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(asset, index) in community_assets"
                                :key="asset.id"
                                class="border-bottom text-xxs"
                                >
                                <td class="text-start"> {{ index + 1 }} </td>
                                <td>
                                  <div class="fw-600">{{ asset.name }}</div>
                                </td>
                                <td class="text-lowercase">{{ asset.category?.name || '—' }}</td>
                                <td class="text-start">
                                    {{ asset.location || '—' }}
                                </td>
                                <td>
                                    {{ asset.creater?.full_name || asset.creater?.name || '—' }}
                                </td>
                                <td class="text-start">
                                  {{ asset.is_booked ? 'booked' : 'available' }}</td>
                                <td class="text-start">
                                    <div class="d-flex justify-content-start gap-1">
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-primary border text-xxs"
                                            data-bs-toggle="modal"
                                            data-bs-target="#bookingsListModal"
                                            @click.stop.prevent="asset_bookings(asset)">
                                            View
                                        </button>
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-success border text-xxs"
                                            v-if="!asset.is_booked"
                                            @click.stop.prevent="edit_asset(asset)">
                                            Edit
                                        </button>
                                        <button type="button"
                                            class="btn btn-light btn-sm rounded text-danger border text-xxs"
                                            v-if="(current_role === 'admin' || asset.creater?.id === current_user_id) && !asset.is_booked"
                                            @click.stop.prevent="delete_asset(asset.id, $event)"
                                            >
                                            Delete
                                        </button>

                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Empty state -->
            <div v-else class="text-center py-5">
                <i class="bi bi-box-seam display-1 text-muted mb-3" aria-hidden="true"></i>
                <p class="text-muted fs-5 mb-1">No assets yet.</p>
                <p class="text-muted text-xxs mb-3">When you create assets, they will appear here.</p>
            </div>
            </div>
            <!-- /ASSETS TABLE -->
          </div>
        </div>
      </div>
      <!-- /Content column -->
    </div>
  </div>
</div>
